// Section 17: priority group 'Idle adults'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { isChild, isElder, peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function idleAdults(_config: Config) {
  return definePriorityGroup({
    id: 'idle-adults',
    label: 'Idle adults',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => p.job === 'rest' && !isChild(ctx.cfg, p) && !isElder(ctx.cfg, p))
        .map((p) => p.id),
  });
}
